import {get, post} from "@/config/api";


const state = {
};

const getters = {};

const mutations = {};

const actions = {
  GetOrderById({}, params) {
    return new Promise((resolve, reject) => {
      get(`order/detail/${params.id}/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  RequestRefund({}, params) {
    return new Promise((resolve, reject) => {
      post(`order/refund/${params.id}/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

